@if (activePayment()) {
  <gc-note-banner
    *ngIf="payment"
    [noteText]="'your_bank_statement_will_display_GoodX_as_the_reference_for_this_payment'"
    [noteTitle]="'please_note'"
    [noteIcon]="'warning'"
    [maxHeight]="'100px'"
    [textColor]="'var(--white)'"
    [type]="'warning'"
    [canClose]="false"
    [animation]="true"
    [hasBreadCrumb]="userID"
  ></gc-note-banner>
  <div class="container" *ngIf="payment && payment.invoices && !payAllInvoices">
    <mat-card class="payment-card mat-elevation-z4">
      <mat-toolbar [class.unpaid]="!payment.paid" class="toolbar">
        <span>{{ payment.paid ? ('paid_total' | translate) : ('unpaid_total' | translate) }}:</span>
        <span>{{ payment.paymentAmount | currency: (currencyCode$ | async) : 'symbol-narrow' }}</span>
      </mat-toolbar>
      <mat-card-header>
        <gc-profile-picture mat-card-avatar [fullName]="payment.servicesProviderName"></gc-profile-picture>
        <mat-card-title>{{ payment.servicesProviderName }}</mat-card-title>
        <mat-card-subtitle>{{ treatingDoctors() }}</mat-card-subtitle>
        <mat-card-subtitle>{{ payment.accountNumber }}</mat-card-subtitle>
      </mat-card-header>
      <button
        *ngIf="!payment.paid"
        mat-flat-button
        color="primary"
        (click)="determinePayment($event, payment)"
        [style.background]="getBackground()"
        [style.color]="getFontColour()"
      >
        <mat-icon>payment</mat-icon>
        {{ 'pay_all_outstanding' | translate }}
      </button>
      <button mat-flat-button *ngIf="payment.paid" (click)="onDownload(payment)" color="accent" type="button" class="hide-on-mobile">
        {{ 'download_summary_of_payments' | translate }}
      </button>
      @if (!userID) {
        <button
          *ngIf="!payment.paid"
          mat-flat-button
          color="primary"
          (click)="loginForStoredCards($event, payment)"
          [style.background]="getBackground()"
          [style.color]="getFontColour()"
        >
          <mat-icon>payment</mat-icon>
          {{ 'pay_all_outstanding_with' | translate }}
        </button>
      }
    </mat-card>
    <div class="invoices-container">
      <div class="invoices mat-elevation-z0" *ngFor="let invoice of invoices">
        <mat-accordion class="invoice-accordion">
          <mat-expansion-panel>
            <mat-expansion-panel-header class="invoice-expansion-header">
              <span class="invoice-expansion-row text-style" [style.color]="hasTheme() === true ? 'black' : 'var(--primary-color)'">
                {{ 'invoice_nr' | translate: { number: invoice.invoice_nr } }}
              </span>
            </mat-expansion-panel-header>
            <span class="invoice-expansion-description">
              <div class="description-intro">
                <span>
                  <strong>{{ 'treatment_date' | translate }}:</strong>
                  &nbsp;
                </span>
                <span>{{ invoice.treatment_date | date: 'shortDate' }}</span>
              </div>
              <div class="description-intro">
                <span>
                  <strong>{{ 'treating_doctor' | translate }}:</strong>
                  &nbsp;
                </span>
                <span>{{ invoice.treating_doc }}</span>
              </div>
              <div class="description-intro">
                <span>
                  <strong>{{ 'patient_name' | translate }}:</strong>
                  &nbsp;
                </span>
                <span>{{ invoice.fullName }}</span>
              </div>
              <div class="description-intro">
                <span>
                  <strong>{{ 'account_number' | translate }}:</strong>
                  &nbsp;
                </span>
                <span>{{ payment.accountNumber }}</span>
              </div>
              <br />
              <mat-divider></mat-divider>
              <div class="mat-elevation-z1">
                <table mat-table [dataSource]="invoice.lines">
                  <!-- Code Column -->
                  <ng-container matColumnDef="code">
                    <th mat-header-cell class="description" *matHeaderCellDef>{{ 'code' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.code }}</td>
                  </ng-container>

                  <!-- Description Column -->
                  <ng-container matColumnDef="description">
                    <th mat-header-cell class="description" *matHeaderCellDef>{{ 'item_description' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.description }}</td>
                  </ng-container>

                  <!-- Total Column -->
                  <ng-container matColumnDef="total">
                    <th mat-header-cell class="description" *matHeaderCellDef>{{ 'total' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.payment_amount | currency: (currencyCode$ | async) : 'symbol-narrow' }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="['code', 'description', 'total']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['code', 'description', 'total']"></tr>
                </table>
              </div>
            </span>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-toolbar color="primary" [style.background]="getBackground()" [style.color]="getFontColour()">
          <span>{{ 'total' | translate }}: {{ invoice.pat_amount | currency: (currencyCode$ | async) : 'symbol-narrow' }}</span>
        </mat-toolbar>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="payment && !payment.invoices">
    <mat-card>
      <mat-card-title>{{ 'invoices' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ '0_invoice_lines' | translate }}</mat-card-subtitle>
    </mat-card>
  </div>
  <div>
    <div class="view-payment" *ngIf="!peachpayEmbedded">
      <gc-view-payment-options [payment]="payment" [payAllInvoices]="payAllInvoices" url="/payments"></gc-view-payment-options>
    </div>
  </div>
  <div class="center" *ngIf="payment && peachpayEmbedded">
    <div class="view-payment" *ngIf="peachpayEmbedded">
      <gc-peachpay-embedding [payment]="payment" (paymentCompleted)="onPaymentCompleted($event)"></gc-peachpay-embedding>
    </div>
  </div>
} @else {
  <div class="doctor-not-found" *ngIf="payment">
    <mat-card class="card">
      <mat-card-header>
        <div mat-card-avatar>
          <button mat-mini-fab color="warn">
            <mat-icon svgIcon="alert-circle-outline"></mat-icon>
          </button>
        </div>
        <mat-card-title>{{ 'not_using_payment_method' | translate }}</mat-card-title>
        <mat-card-subtitle>{{ 'might_be_old_link' | translate }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p class="info-text">
          {{ 'unable_to_make_payment' | translate }}
          <br />
          {{ 'please_contact_your_practice_for_more_information' | translate }}
        </p>
        <span *ngIf="doctor$ | async as doctor">
          <p class="info-text">{{ 'contact_details_menu_instruction' | translate }}</p>
          <div class="doctor-card">
            <gc-doctor-card [doctor]="doctor"></gc-doctor-card>
          </div>
        </span>
      </mat-card-content>
    </mat-card>

    <mat-card-actions class="other-actions row-center">
      <p class="or-text">{{ 'or_you_can' | translate }}</p>
      <div>
        <button mat-stroked-button class="action-button" routerLink="/doctors">
          <mat-icon svgIcon="magnify"></mat-icon>
          {{ 'search_for_a_doctor' | translate }}
        </button>
      </div>
      <div>
        <button mat-stroked-button class="return-button" routerLink="/">
          <mat-icon svgIcon="home"></mat-icon>
          {{ 'go_to_home' | translate }}
        </button>
      </div>
      <div>
        <button mat-stroked-button class="return-button" (click)="location.back()">
          <mat-icon svgIcon="arrow-left"></mat-icon>
          {{ 'go_back' | translate }}
        </button>
      </div>
      <img class="error-img" src="assets/images/Oops-error.svg" alt="{{ 'oops_error' | translate }}" />
    </mat-card-actions>
  </div>
}
